/**
 * 获取链接的参数值
 * @param key 参数键名
 * @param urlStr 链接地址，默认为当前浏览器的地址
 */
export const getUrlValue = (key: string, urlStr: string = location.href): string => {
  if (!urlStr || !key) return '';
  try {
    const url = new URL(urlStr);
    return url.searchParams.get(key) ?? '';
  } catch {
    return '';
  }
};
